import { TValidationRules } from '@/main/store/@types/page';
import { DropdownList } from '@/main/store/@types/dropdown.d';

export const enum PneuPart {
	Disk, Pneu
}

export const editMutations = <const>{
	SKLAD_MISTO_SELECT_MAPPER: 'SKLAD_MISTO_SELECT_MAPPER',
	ZAKAZKA_SELECT_MAPPER: 'ZAKAZKA_SELECT_MAPPER',
	ZAKAZNIK_SELECT_MAPPER: 'ZAKAZNIK_SELECT_MAPPER',
	VOZIDLO_SELECT_MAPPER: 'VOZIDLO_SELECT_MAPPER',
	VSTUP_ZAKAZNIK_SELECT_MAPPER: 'VSTUP_ZAKAZNIK_SELECT_MAPPER',
	PRACOVNIK_SELECT_MAPPER: 'PRACOVNIK_SELECT_MAPPER',
	NAKLAD_STREDISKO_SELECT_MAPPER: 'NAKLAD_STREDISKO_SELECT_MAPPER',
	SKLAD_PNEU_TEXTY_SELECT_MAPPER: 'SKLAD_PNEU_TEXTY_SELECT_MAPPER',
	SET_POLOZKA: 'setPolozka',
	UPDATE_ALL_POLOZKA: 'updateAllPolozka',
	INCREASE_WHEEL: 'increaseWheel',
	DECREASE_WHEEL: 'decreaseWheel',
	UPDATE_POLOZKY_VALIDATION_RULES: 'updatePolozkyValidationRules',
	SET_POLOZKA_DEFAULT: 'setPolozkaDefault',
};

export const listMutations = <const>{
	SKLAD_MISTO_OD_SELECT_MAPPER: 'SKLAD_MISTO_OD_SELECT_MAPPER',
	SKLAD_MISTO_DO_SELECT_MAPPER: 'SKLAD_MISTO_DO_SELECT_MAPPER',
	VOZIDLO_SELECT_MAPPER: 'VOZIDLO_SELECT_MAPPER',
	ZAKAZNIK_SELECT_MAPPER: 'ZAKAZNIK_SELECT_MAPPER',
	VSTUP_ZAKAZNIK_SELECT_MAPPER: 'VSTUP_ZAKAZNIK_SELECT_MAPPER',
	PRACOVNIK_SELECT_MAPPER: 'PRACOVNIK_SELECT_MAPPER',
	VSTUP_PRACOVNIK_SELECT_MAPPER: 'VSTUP_PRACOVNIK_SELECT_MAPPER',
};

export const editActions = <const>{
	CREATE_ALL_PNEU: 'createPneus',
	LOAD_POLOZKY_DATA: 'loadPolozkyData',
	SAVE_ALL_PNEU: 'savePneus',
	PNEU_DEFAULT: 'pneuDefault',
	SKLAD_PNEU_SELECT_ZMENA: 'zmenaSkladPneu',
	SKLAD_MISTO_SELECT_ZMENA: 'zmenaSkladMisto',
	ZAKAZKA_SELECT_ZMENA: 'zmenaZakazka',
	VOZIDLO_SELECT_ZMENA: 'zmenaVozidlo',
	ZAKAZNIK_SELECT_ZMENA: 'zmenaZakaznik',
	PRACOVNIK_SELECT_ZMENA: 'zmenaPracovnik',
};

export type Pneu = {
	ZaznamId: null | number,
	PneuskladId: null | number,
	PneuPrp: boolean,
	VyrobekpneuId: null | number,
	PneuText: null | string,
	PneuPzn: null | number,
	PneusirkaId: null | number,
	PneuvyskaId: null | number,
	PneurozmerId: null | number,
	PrychlostPzn: null | number,
	PnosnostPzn: null | number,
	DezenHloubka: null | number,
	PstavPzn: null | number,
	DiskPrp: boolean,
	VyrobekdiskId: null | number,
	DiskText: null | string,
	DisksirkaId: null | number,
	DiskrozmerId: null | number,
	DstavPzn: null | number,
	KrytPrp: null | boolean,
	SroubPocet: null | number,
	PneuPoznamka: null | string,
	DiskPoznamka: null | string,
	VstupDat: null | Date,
	VstupPracId: null | number,
	EditDat: null | Date,
	EditPracId: null | number,
	PkonstrPzn: null | number,
	DiskPzn: null | number,
	PneumontPzn: null | number,
	ZakazkaId: null | number,
	Et: null | number,
	Prumstrotv: null | number,
	Roztecsrou: null | number,
	VyrobaRok: null | number,
	ValidationRules: TValidationRules,
	DropDownList: DropdownList,
};
